import React from "react";
import PluginBridge from "../index";

/**
 * Slot de ações no modal "Criar Ticket" (ao lado do título).
 *
 * Plugins declaram actions com `slot: "new-ticket"` no metadata.
 * Útil, por exemplo, para um canal que exige template ao abrir o ticket.
 *
 * Props (contexto repassado ao plugin):
 *   contactId   — id do contato selecionado (se houver)
 *   queueId     — id da fila selecionada (se houver)
 *   whatsappId  — id da conexão selecionada (se houver)
 *   companyId   — id da empresa (necessário para a rota do plugin)
 */
export default function NewTicketSlot({ contactId, queueId, whatsappId, companyId }) {
  return (
    <PluginBridge
      slot="new-ticket"
      as="buttons"
      context={{ contactId, queueId, whatsappId, companyId }}
    />
  );
}
